import getProfielService from '../services/components/get_profile.jsx'


const getState = (profileState, display) =>

({ 
    type: "GET_PROFILE",
     profileState, 
     display 
})

export const getProfileAction = (history) => dispatch => {
    let state = [];
    let display = false;

    getProfielService((data, msg) => {
        display = true
        if (msg === "success") {
            try {
                localStorage.setItem("mailingId", data.mailingInformation.mailingId || null)
                
            } catch (e) {
            }

            state = {
                status: 200,
                body: data
            }
        } else {
            state = data
        }
        dispatch(getState(state, display))
    },history)
} 

export const clearProfileAction = () => dispatch => {
    let display = false;
    let state = {
        status: 204,
        body:{}
    }
    dispatch(getState(state,display))
}


// WEBPACK FOOTER //
// ./src/actions/getprofileaction.jsx